import { api } from '../../../general/apiScenarios';
import { lm } from '../../listenerMiddleware';
import * as googleBulkActions from './actions';
import { runTask } from '@myua/api';
import { getCurrentInfo } from './selectors';
import { z } from 'zod';
import Notifications from 'react-notification-system-redux';
import { getShareID } from '../app/selectors';

export const googleBulkListeners = () => {
  watchLinkRequested();
};

function watchLinkRequested() {
  lm.takeEvery(googleBulkActions.linkRequested, async (_, { getState, dispatch }) => {
    const { inProgress, hash, nodeIds } = getCurrentInfo(getState());
    const shareId = getShareID(getState());

    if (inProgress) {
      return;
    }

    dispatch(googleBulkActions.setInProgress({ hash, inProgress: true }));

    const result = await api.fs.createGoogleBulkLink(nodeIds, shareId);

    if (!result.success) {
      dispatch(googleBulkActions.setInProgress({ hash, inProgress: false }));
      const parsed = z.object({ detail: z.string() }).safeParse(result.data.response);
      dispatch(
        Notifications.error({
          title: 'Failed to run task for creating Google Drive link',
          message: parsed.success ? parsed.data.detail : undefined,
        }),
      );
      return;
    }

    const taskId = result.data.response.task_id;
    const taskResult = await runTask<string>(taskId, 2000, undefined, ({ status, data }) => {
      if (status === 'STARTED') {
        const parsed = z.object({ progress: z.number() }).safeParse(data);
        if (parsed.success) {
          dispatch(googleBulkActions.setProgressValue({ hash, value: parsed.data.progress }));
        }
      }
    });

    dispatch(googleBulkActions.setInProgress({ hash, inProgress: false }));

    if (taskResult.success) {
      dispatch(googleBulkActions.linkCreated({ hash, link: taskResult.data }));
    } else {
      dispatch(
        Notifications.error({
          title: 'Failed to create Google Drive Link',
          message: taskResult.error,
        }),
      );
    }
  });
}
